import { InternalAxiosRequestConfig } from 'axios'

import { getPartnerPublicKey } from '@percent/education-hosted-form/utils/getPartnerPublicKey'
import { storage } from '@percent/education-hosted-form/utils/storage'

export const requestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const jwtToken = storage.getItem('jwtToken')

  if (jwtToken) {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: getPartnerPublicKey(jwtToken)
      },
      withCredentials: true
    } as unknown as InternalAxiosRequestConfig
  }

  return config
}
